<template>
  <div class="ColorList__Row items-center justify-start py-1">
    <div
      @click.stop.prevent="click()"
      class="border border-gray-400 border-dashed flex gap-x-2 items-center px-2 !py-1 cursor-pointer flex-grow bg-white group hover:border-bc-blue"
    >
      <aw-icon
        icon="plus"
        class="w-4 h-4  text-gray-400 group-hover:text-bc-blue"
      ></aw-icon>
      <span class="text-gray-400 group-hover:text-bc-blue">
        {{ $t('Add new color row') }}
      </span>
    </div>
  </div>
</template>

<script>
import BaseAddElement from '../../../mixins/BaseAddElement'
export default {
  mixins: [BaseAddElement],
  methods: {
    click() {
      this.addChild('color-row', {
        name: this.$t('name'),
        value: this.$t('value')
      })
    }
  }
}
</script>
